import { DOCAIApi, ExtractFileRequest, FileAnalytic, FileAnalyticStatus } from "@/services/DocAIService";
import { startLoading, stopLoading } from "@/store/loading";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { message } from 'antd';
import { concat, interval, of } from "rxjs";
import { catchError, filter, map, switchMap, takeWhile, tap } from "rxjs/operators";
import { RootEpic } from "./types";

interface DOCAIState {
  loading: boolean;
  fileAnalytic: FileAnalytic | null;
  fileStatus: FileAnalyticStatus | null;
  error: string | null;
  analyticFileId?: string | null;
}

const apiUrl =  DOCAIApi.getHost(DOCAIApi.ApiHost);

const initialState: DOCAIState = {
  loading: false,
  fileAnalytic: null,
  fileStatus: null,
  error: null,
  analyticFileId: ''
};

const DOCEAISlice = createSlice({
  name: "docai",
  initialState,
  reducers: {
    extractFileRequest: (state, action: PayloadAction<ExtractFileRequest>) => {
      state.loading = true;
      state.error = null;
      state.analyticFileId = action.payload.guid_file;
    },
    extractFileSuccess: (state, action) => {
      state.loading = false;
      state.fileAnalytic = action.payload;
    },
    extractFileFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getFileStatusRequest: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    getFileStatusSuccess: (state, action: PayloadAction<FileAnalyticStatus>) => {
      state.loading = false;
      state.fileStatus = action.payload;
    },
    getFileStatusFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    getFileStatusAnalytic: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    setAnalyticFileId: (state, action: PayloadAction<string>) => {
      state.analyticFileId = action.payload;
    },
  },
});



export const extractFileByPathFile$: RootEpic = (action$, state$) =>
  action$.pipe(
    filter(DOCAIActions.extractFileRequest.match),
    switchMap((action) => {
      return concat(
        of(startLoading({ key: "extractFile" })),
        DOCAIApi.Post.extractFileByPathFile(action.payload).pipe(
          switchMap((res: FileAnalytic) => {
            const guidFile = res?.file_upload?.guid_file;
            if (!guidFile) {
              message.error("No guid_file found in response");
              return concat(
                of(DOCAIActions.extractFileFailure("No guid_file found in response")),
                of(stopLoading({ key: "extractFile" }))
              );
            }

const poll$ = interval(3000).pipe(
  switchMap(() =>
    DOCAIApi.Get.getTaskByGuidFile(guidFile).pipe(
      tap((statusRes: FileAnalyticStatus) => {
        if (statusRes?.status === "success") {
          message.success("Analytic done!");
        }
      })
    )
  ),
  map((statusRes: FileAnalyticStatus) => DOCAIActions.getFileStatusSuccess(statusRes)),
  takeWhile((action) => action.payload?.status !== "success", true) // dừng khi status = success, include giá trị cuối
);

            return concat(
              of(DOCAIActions.setAnalyticFileId(guidFile)),
              of(DOCAIActions.extractFileSuccess(res)),
              poll$,
              of(stopLoading({ key: "extractFile" }))
            );
          }),
          catchError((err) => {
            message.error(err.response?.detail || err.response?.message || "error extracting file");
            return concat(
              of(DOCAIActions.extractFileFailure(err.message || "Error extracting file")),
              of(stopLoading({ key: "extractFile" }))
            );
          })
        )
      );
    })
  );


export const getFileStatusByGuidFile$: RootEpic = (action$) =>
  action$.pipe(
    filter(DOCAIActions.getFileStatusRequest.match),
    switchMap((action) =>
      DOCAIApi.Get.getTaskByGuidFile(action.payload).pipe(
        switchMap((res) => {
          const sumPage = res?.sum_page;
          const totalPage = res?.total_page;
          if (sumPage !== undefined && totalPage !== undefined && sumPage === totalPage) {
            return [
              DOCAIActions.getFileStatusSuccess(res),
              stopLoading({ key: "extractFile" })
            ];
          }
          return [DOCAIActions.getFileStatusSuccess(res)];
        }),
        catchError((err) =>
          of(DOCAIActions.getFileStatusFailure(err.message || "Error fetching file status"))
        )
      )
    ),
  );


export const viewAnalyticEpic: RootEpic = (action$) =>
  action$.pipe(
    filter((action) => action.type === "view-analytic"),
    map((action: any) => {
      const item = action.payload;
      if (!item) return { type: "docai/viewAnalyticSkipped" };

      const domain = window.location.origin;
      const analyticUrl = `${DOCAIApi.getHost(DOCAIApi.ApiHost)}/pdf/view?path=${DOCAIApi.getHost(DOCAIApi.ApiHost)}/file/view-pdf-guid/${item.baseFileId}&filename=${item.filename}&baseFileId=${item.baseFileId}&baseMajorRev=${item.baseMajorRev}&baseMinorRev=${item.baseMinorRev}`;
      window.open(analyticUrl, "_blank");

      return { type: "docai/viewAnalyticOpened" };
    })
  );

// export const getFileStatusAnalytic:RootEpic =()=>
//   action$.pipe()




export const DOCAIEpics = [
  extractFileByPathFile$,
  getFileStatusByGuidFile$,
  viewAnalyticEpic
]
export const { getFileStatusRequest, getFileStatusFailure, getFileStatusSuccess, extractFileRequest, extractFileSuccess, extractFileFailure } = DOCEAISlice.actions;
export const DOCAIActions = DOCEAISlice.actions;
export default DOCEAISlice.reducer


